import { render, staticRenderFns } from "./tablaResumen.vue?vue&type=template&id=176fa776&"
import script from "./tablaResumen.vue?vue&type=script&lang=ts&"
export * from "./tablaResumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports